import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAsync } from 'react-use';
import * as businessService from '../../data-layer/business/service';
import { BusinessStatsModel } from '../../data-layer/business/types';
import {
    BusinessStatisticSkeleton,
    BusinessStatisticSummaryUI,
} from '../../ui/business/BusinessStatisticSummaryUI';
import { Flex } from '../../ui/layout/Flex';
import { hasAccessToBusinessStat } from '../../utils/accessService';
import { useCurrentUser } from '../users/useCurrentUser';
import { Dropdown } from './FeedManagement';

type Option<TValue> = {
    displayName: string;
    value: TValue;
};

const DEFAULT_STAT_PERIOD = '7';

const PERIOD_OPTIONS: Option<string>[] = [
    { displayName: 'за 7 дней', value: '7' },
    { displayName: 'за 14 дней', value: '14' },
    { displayName: 'за 30 дней', value: '30' },
    { displayName: 'за весь период', value: 'undefined' },
];

interface BusinessStatisticProps {
    stats: BusinessStatsModel;
}

export const BusinessStatisticSummary = () => {
    const { businessId } = useParams();
    const [period, setPeriod] = useState<string | null>(DEFAULT_STAT_PERIOD);
    const [businessStatistic, setBusinessStatistic] = useState<BusinessStatisticProps | undefined>(
        undefined,
    );
    const currentUser = useCurrentUser();
    const { loading: statisticLoading } = useAsync(async () => {
        setBusinessStatistic(undefined);
        if (businessId && hasAccessToBusinessStat(businessId, currentUser)) {
            setBusinessStatistic(
                await businessService.loadBusinessStatistic(
                    businessId,
                    period === 'undefined' ? undefined : period,
                ),
            );
        }
    }, [businessId, period]);

    const periodChanged = useCallback(
        (value: string | null) => {
            setPeriod(value);
        },
        [setPeriod],
    );

    return (
        <Flex width="100%">
            <Flex
                direction="row"
                width="100%"
                px={3}
                alignItems="center"
                spacing={{ xs: 1.5, sm: 2 }}
                borderRadius={{ sm: 2 }}
                mb={2}
                zIndex={2}
            >
                <Dropdown
                    value={period}
                    placeholder="Период"
                    options={PERIOD_OPTIONS}
                    onChange={periodChanged}
                />
            </Flex>
            {statisticLoading ? (
                <BusinessStatisticSkeleton />
            ) : (
                businessStatistic?.stats && (
                    <BusinessStatisticSummaryUI statistic={businessStatistic.stats} />
                )
            )}
        </Flex>
    );
};
